import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SelectGroup from './select-group';
import InputGroup from './input-group';
import { months, days } from '../../util';
import dayjs from 'dayjs';

class Component extends BaseComponent {
    constructor() {
        super();
        this.years = [];
        for (let y = dayjs().year(); y >= 1900; y--) {
            this.years.push(y);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps != this.props) {
            return true;
        }

        return false;
    }

    render({ name, label, date, month, day, year, onChange, disabled }) {
        return (
            <birth-date-group>
                <row className='is-wrap'>
                    <column className='is-6 is-12-tablet is-12-mobile has-padding-10-right-desktop'>
                        <span className='is-visible-desktop'>
                            <SelectGroup
                                name={`${name}_month`}
                                label={label}
                                value={month.value}
                                placeholder='MONTH'
                                options={months}
                                error={month.error}
                                onChange={onChange}
                                disabled={disabled}
                            />
                        </span>
                        <span className='is-hidden-desktop'>
                            <InputGroup
                                type='date'
                                name={name}
                                label={label}
                                placeholder='SELECT DATE'
                                value={date.value}
                                error={date.error}
                                onInput={onChange}
                                disabled={disabled}
                            />
                        </span>
                    </column>
                    <column className='is-3 is-visible-desktop has-padding-10-right'>
                        <SelectGroup
                            name={`${name}_day`}
                            label='&nbsp;'
                            value={day.value}
                            placeholder='DAY'
                            options={days}
                            error={day.error}
                            onChange={onChange}
                            disabled={disabled}
                        />
                    </column>
                    <column className='is-3 is-visible-desktop'>
                        <SelectGroup
                            name={`${name}_year`}
                            label='&nbsp;'
                            value={year.value}
                            placeholder='YEAR'
                            options={this.years}
                            error={year.error}
                            onChange={onChange}
                            disabled={disabled}
                        />
                    </column>
                </row>
            </birth-date-group>
        );
    }
}

export default connect()(Component);
